export default __webpack_public_path__ + "static/media/pokemon_ace_spec_rare.a0eaf8c4.svg";